/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-non-null-assertion */
import React, { useMemo } from 'react';
import { createContext, PropsWithChildren, useEffect, useState } from 'react';
import { ILwpWidgetProps } from '../../components/lwp-widget';

export interface ILwpWidgetPropsContext {
  widgetProps: ILwpWidgetProps;
  setWidgetProps(props: ILwpWidgetProps): void;
}

export const LwpWidgetPropsContext = createContext<ILwpWidgetPropsContext>(null!);

export function LwpWidgetPropsProvider(props: PropsWithChildren<any>) {
  const [widgetProps, setWidgetProps] = useState<ILwpWidgetProps>({});

  const contextValue = useMemo(() => ({ widgetProps, setWidgetProps }), [widgetProps]);

  return <LwpWidgetPropsContext.Provider value={contextValue}>{props.children}</LwpWidgetPropsContext.Provider>;
}
